<div class="header">
    <h2>{{ 'reflections.modal.edit.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="reflections-edit-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'reflections.error.unavailable' | translate" />
} @else if (reflection(); as reflection) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
        <div class="section">
            <h2>{{ 'reflections.fieldset.basic' | translate }}</h2>
            <app-form-input
                [control]="form.controls.name"
                [label]="'reflections.form.name' | translate"
                [placeholder]="'reflections.form.name.placeholder' | translate"
                inputId="name"
                testId="reflections-edit-name"
            />
            <app-form-textarea
                [control]="form.controls.questionText"
                [label]="'reflections.form.questionText' | translate"
                [placeholder]="'reflections.form.questionText.placeholder' | translate"
                inputId="questionText"
                testId="reflections-edit-question-text"
            />
        </div>
    </form>

    <div class="footer">
        <p-button
            [label]="'reflections.form.cancel' | translate"
            [outlined]="true"
            severity="secondary"
            data-test="reflections-edit-cancel"
            (onClick)="close()"
        />
        <p-button
            type="submit"
            [label]="'reflections.form.save' | translate"
            [loading]="saving()"
            [disabled]="form.disabled"
            data-test="reflections-edit-save"
            (onClick)="onSubmit()"
        />
    </div>
}
